import { createMuiTheme } from '@material-ui/core';
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';

type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};

declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey extends overridesNameToClassKey {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MuiPickersToolbarText(
      props?: any
    ): Record<'toolbarTxt' | 'toolbarBtnSelected', string>;
  }
}

interface NeutralOptions {
  secondary: string;
  inactive: string;
  border: string;
  tertiary: string;
}

declare module '@material-ui/core/styles/createPalette' {
  interface PaletteOptions {
    success?: PaletteColorOptions;
    warning?: PaletteColorOptions;
    border?: PaletteColorOptions;
    neutrals?: NeutralOptions;
  }
}

export default createMuiTheme({
  palette: {
    success: {
      light: '#E5F9F2',
      main: '#9FE7CF',
      dark: '#31CC97',
      contrastText: 'rgba(0, 0, 0, 0.87)'
    },
    warning: {
      light: '#FBF2D0',
      main: '#F6E093',
      dark: '#F6C343',
      contrastText: 'rgba(0, 0, 0, 0.87)'
    },
    error: {
      light: '#FAD2D1',
      main: '#F07B75',
      dark: '#E03229',
      contrastText: 'rgba(0, 0, 0, 0.87)'
    },
    primary: {
      light: '#E1F0FF',
      main: '#4C7CFD',
      dark: '#023EE3',
      contrastText: 'rgba(0, 0, 0, 0.87)'
    },
    background: {
      default: '#F6F8FC'
    },
    border: {
      light: '#E1F0FF',
      main: '#D4DBE4',
      dark: '#023EE3'
    },
    divider: '#E3EBF6',
    type: 'light',
    text: {
      primary: '#12253F',
      secondary: '#6E84A3',
      hint: '#4C7CFD'
    },
    neutrals: {
      secondary: '#617799',
      inactive: '#B8C3D2',
      border: '#E3EBF6',
      tertiary: '#E1F0FF'
    },
    action: {
      disabled: '#E9EEF7'
    }
  },
  typography: {
    fontFamily: 'TTCommons, Arial, sans-serif',
    h1: {
      fontFamily: 'TTCommons, Arial, sans-serif',
      fontWeight: 500,
      fontSize: '45px'
    },
    h2: {
      fontFamily: 'TTCommons, Arial, sans-serif',
      fontWeight: 500,
      fontSize: '20px'
    },
    h3: {
      fontFamily: 'TTCommons, Arial, sans-serif',
      fontWeight: 500,
      fontSize: '17px'
    },
    h4: {
      fontFamily: 'TTCommons, Arial, sans-serif',
      fontWeight: 500,
      fontSize: '15px',
      color: '#6E84A3',
      letterSpacing: '0.5px'
    },
    body1: {
      fontFamily: 'TTCommons, Arial, sans-serif',
      fontWeight: 400,
      fontSize: '14px',
      color: '#12253F',
      letterSpacing: '0.5px'
    },
    body2: {
      fontFamily: 'TTCommons, Arial, sans-serif',
      fontWeight: 400,
      fontSize: '14px',
      color: '#6E84A3',
      letterSpacing: '0.5px'
    }
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '14px',
        backgroundColor: '#2F68FD'
      }
    },
    MuiPickersClockNumber: {
      clockNumberSelected: {
        color: 'white'
      }
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        fontFamily: 'TTCommons, Arial, sans-serif',
        color: '#E7E7E7',
        fontSize: '30px'
      },
      toolbarBtnSelected: {
        color: 'white'
      }
    }
  }
});
